import React, {
  lazy,
  Suspense
} from "react";

import {
  Route,
  Routes
} from "react-router-dom";

import {

  Skeleton
} from "@mui/material";

/* Lazy Imports */

const Dashboard = lazy(() =>
  import("../pages/Dashboard")
);

const Createnote = lazy(() =>
  import("../pages/CreateNote")
);

const NoteEditor = lazy(() =>
  import("../components/NoteEditor")
);

const NoteDetails = lazy(() =>
  import("../components/NoteDetails")
);

const AppRoutes = () => {

  return (

    <Suspense
      fallback={
        <Skeleton
  variant="rounded"
  height={400}
/>

      }
    >

      <Routes>

        <Route
          path="/"
          element={<Dashboard />}
        />

        <Route
          path="/create"
          element={<Createnote />}
        />

        <Route
          path="/edit/:id"
          element={<NoteEditor />}
        />

        <Route
          path="/note/:id"
          element={<NoteDetails />}
        />

      </Routes>

    </Suspense>

  );

};

export default AppRoutes;